import React from 'react';
import PropTypes from "prop-types";

import { Router, Route, Switch, Redirect } from "react-router-dom";
import { createBrowserHistory } from "history";

import LandingPage from "views/landingPage/landingPage.js";
import FacilityView from "views/facilityView/facilityView.js";
import ReactGA from 'react-ga';


var hist = createBrowserHistory();

export default function MainComponent(props) {
    const { changeColor } = props;
    ReactGA.initialize('UA-5641005-9');

    hist.listen((location) => {
        ReactGA.set({ page: location.pathname });
        ReactGA.pageview(location.pathname)
    });

    return (
        <Router history={hist}>
            <Switch>
                <Route path='/facilityView/:widgetId' render={(props) => (<FacilityView {...props} changeColor={changeColor} />)} />
                <Route path='/landingPage/:widgetId' render={(props) => (<LandingPage {...props} changeColor={changeColor} />)} />
                <Route path='/landingPage' render={(props) => (<LandingPage {...props} changeColor={changeColor} />)} />
                <Redirect from="/:widgetId" to="/landingPage/:widgetId" />
                <Redirect from="/" to="/landingPage" />
            </Switch>
        </Router>
    );
}

MainComponent.propTypes = {
    changeColor: PropTypes.func.isRequired,
};
